import { SvelteComponent, init, safe_not_equal, empty, insert, transition_out, check_outros, transition_in, detach, createEventDispatcher, group_outros, element, attr, noop, create_component, mount_component, destroy_component, create_slot, space, append, update_slot_base, get_all_dirty_from_scope, get_slot_changes, destroy_each } from '../../../../external_node_modules/svelte/internal/index.mjs.js';
import { t } from '../../../../i18n.js';
import ProductTile from '../ProductTile/ProductTile.svelte.js';
import '../../../../core/entity/product.entity.js';
import './Showcase.css.js';

/* src/ui/shared/components/Showcase/Showcase.svelte generated by Svelte v3.44.2 */
const get_additional_products_slot_changes = dirty => ({});
const get_additional_products_slot_context = ctx => ({});

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[10] = list[i];
	return child_ctx;
}

// (44:0) {:else}
function create_else_block(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			div.textContent = `${t('Ничего не найдено')}`;
			attr(div, "class", "products-empty wcl-1dnu93x");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (32:0) {#if products && products.length > 0}
function create_if_block(ctx) {
	let div;
	let t_1;
	let current;
	let each_value = /*productsToDisplay*/ ctx[4];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	const additional_products_slot_template = /*#slots*/ ctx[7]["additional-products"];
	const additional_products_slot = create_slot(additional_products_slot_template, ctx, /*$$scope*/ ctx[6], get_additional_products_slot_context);

	return {
		c() {
			div = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t_1 = space();
			if (additional_products_slot) additional_products_slot.c();
			attr(div, "class", "products wcl-1dnu93x");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div, null);
			}

			append(div, t_1);

			if (additional_products_slot) {
				additional_products_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*productComponent, productsToDisplay, onProductBuy, onShowDetails*/ 29) {
				each_value = /*productsToDisplay*/ ctx[4];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(div, t_1);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			if (additional_products_slot) {
				if (additional_products_slot.p && (!current || dirty & /*$$scope*/ 64)) {
					update_slot_base(
						additional_products_slot,
						additional_products_slot_template,
						ctx,
						/*$$scope*/ ctx[6],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[6])
						: get_slot_changes(additional_products_slot_template, /*$$scope*/ ctx[6], dirty, get_additional_products_slot_changes),
						get_additional_products_slot_context
					);
				}
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			transition_in(additional_products_slot, local);
			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			transition_out(additional_products_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_each(each_blocks, detaching);
			if (additional_products_slot) additional_products_slot.d(detaching);
		}
	};
}

// (34:4) {#each productsToDisplay as product}
function create_each_block(ctx) {
	let switch_instance;
	let switch_instance_anchor;
	let current;
	var switch_value = /*productComponent*/ ctx[0];

	function switch_props(ctx) {
		return { props: { product: /*product*/ ctx[10] } };
	}

	if (switch_value) {
		switch_instance = new switch_value(switch_props(ctx));
		switch_instance.$on("buy", /*onProductBuy*/ ctx[2]);
		switch_instance.$on("showDetails", /*onShowDetails*/ ctx[3]);
	}

	return {
		c() {
			if (switch_instance) create_component(switch_instance.$$.fragment);
			switch_instance_anchor = empty();
		},
		m(target, anchor) {
			if (switch_instance) {
				mount_component(switch_instance, target, anchor);
			}

			insert(target, switch_instance_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (switch_value !== (switch_value = /*productComponent*/ ctx[0])) {
				if (switch_instance) {
					group_outros();
					const old_component = switch_instance;

					transition_out(old_component.$$.fragment, 1, 0, () => {
						destroy_component(old_component, 1);
					});

					check_outros();
				}

				if (switch_value) {
					switch_instance = new switch_value(switch_props(ctx));
					switch_instance.$on("buy", /*onProductBuy*/ ctx[2]);
					switch_instance.$on("showDetails", /*onShowDetails*/ ctx[3]);
					create_component(switch_instance.$$.fragment);
					transition_in(switch_instance.$$.fragment, 1);
					mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
				} else {
					switch_instance = null;
				}
			}
		},
		i(local) {
			if (current) return;
			if (switch_instance) transition_in(switch_instance.$$.fragment, local);
			current = true;
		},
		o(local) {
			if (switch_instance) transition_out(switch_instance.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(switch_instance_anchor);
			if (switch_instance) destroy_component(switch_instance, detaching);
		}
	};
}

function create_fragment(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*products*/ ctx[1] && /*products*/ ctx[1].length > 0) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;

	var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
		function adopt(value) {
			return value instanceof P
			? value
			: new P(function (resolve) {
						resolve(value);
					});
		}

		return new (P || (P = Promise))(function (resolve, reject) {
				function fulfilled(value) {
					try {
						step(generator.next(value));
					} catch(e) {
						reject(e);
					}
				}

				function rejected(value) {
					try {
						step(generator["throw"](value));
					} catch(e) {
						reject(e);
					}
				}

				function step(result) {
					result.done
					? resolve(result.value)
					: adopt(result.value).then(fulfilled, rejected);
				}

				step((generator = generator.apply(thisArg, _arguments || [])).next());
			});
	};

	let { productComponent } = $$props;
	let { products } = $$props;
	let { hideUnPurchasable = false } = $$props;
	const dispatch = createEventDispatcher();

	if (!productComponent) {
		productComponent = ProductTile;
	}

	function onProductBuy(event) {
		return __awaiter(this, void 0, void 0, function* () {
			dispatch('buy', { product: event.detail.product });
		});
	}

	function onShowDetails(event) {
		dispatch('showDetails', { product: event.detail.product });
	}

	const productsToDisplay = products && hideUnPurchasable
	? products.filter(product => product.isPurchasable)
	: products;

	$$self.$$set = $$props => {
		if ('productComponent' in $$props) $$invalidate(0, productComponent = $$props.productComponent);
		if ('products' in $$props) $$invalidate(1, products = $$props.products);
		if ('hideUnPurchasable' in $$props) $$invalidate(5, hideUnPurchasable = $$props.hideUnPurchasable);
		if ('$$scope' in $$props) $$invalidate(6, $$scope = $$props.$$scope);
	};

	return [
		productComponent,
		products,
		onProductBuy,
		onShowDetails,
		productsToDisplay,
		hideUnPurchasable,
		$$scope,
		slots
	];
}

class Showcase extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			productComponent: 0,
			products: 1,
			hideUnPurchasable: 5
		});
	}
}

export { Showcase as default };
//# sourceMappingURL=Showcase.svelte.js.map
